var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('a',{on:{"click":function($event){$event.preventDefault();return _vm.openCancelOrderModal($event)}}},[_vm._t("default",[_vm._v(_vm._s(_vm.$t("_.cancel_order")))])],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }